import styled from 'styled-components'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { SpecialOutlineButtonLink } from '@chegg-wt/core/theme/fanta/button'

export const RedirectButton = styled(SpecialOutlineButtonLink)`
  margin-top: 15px;
  margin-bottom: 38px;
  width: 215px;
`

interface CardWrapperProps {
  homePage: boolean
}

export const CardWrapper = styled.div.attrs({
  role: 'region',
  'aria-label': 'Cite More Card',
})<CardWrapperProps>`
  min-width: 300px;
  text-align: ${(props) => (props.homePage ? 'center' : 'initial')};
  @media screen and (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex: 0 0 48%;
  }
  @media screen and (max-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    text-align: center;
  }
`

export const Heading = styled.h2`
  font-family: Aspira;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 36px;
`

export const SubHeading = styled.h3`
  font-family: Aspira;
  font-style: normal;
  font-size: 24px;
  line-height: 32px;
`
